import { render, staticRenderFns } from "./SidebarFjolla.vue?vue&type=template&id=3edc1f95&scoped=true"
import script from "./SidebarFjolla.vue?vue&type=script&lang=js"
export * from "./SidebarFjolla.vue?vue&type=script&lang=js"
import style0 from "./SidebarFjolla.vue?vue&type=style&index=0&id=3edc1f95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edc1f95",
  null
  
)

export default component.exports